<!--
    @component searchform 查询条件组件
    @props
        {Array} formItems - 搜索表单配置  []
        {String} labelWidth - 表单label宽度  '120px'
    @formItems {Object}
        属性名 | 描述 | 类型 | 默认值
        label 项目名 String -
        value 项目值 对应提交给服务端的key [String|Array] -
        placeholder 输入框占位文本 [String|Array] -
        default 默认值 null -
        hidden 隐藏 隐藏该项目 但值依旧存在
        disabled 禁用 Boolean false
        required 必填 Boolean false
        errorMsg 校验错误信息 String -
        customWidth 删格化占用栏位 一行24格 具体继承自form-item、elcol、elrow删格化参数
        itemType 该项的类型 String 默认为存在
          occultation 可展开收起 隐藏的项
          display 一直存在的 不可展开收起
        type 该项的类型 elInput, elSelect, elDatePicker, InputDialog
          elSelect 下拉框
              dict 对应的字典key 用于服务端请求 也可是数组需要和服务端对应 [Array|String]
                  [{ sCodeName: 'name', sCodeValue: 123 }]
                  or 'base.yes-no'
          elDatePicker 日期选择框
              *!!* value、placeholder、default 转为Array传输格式
              value 对应用户选择的第一个时间第二个时间 Array
                  ['startTime', 'endTime']
              default 默认值
                  ['2020-10-01', new Date().getTime()],
              placeholder 输入框占位文本 Array
          dateType 日期类型选择  datetimerange为日期时间选择器，如果不传为默认daterange
          cndInputDialog 全文检索框
              labelDefault 全文检索框的文本值
              dialogType 对应的业务弹窗类型
                  area 地区
                  artno 货号
                  cost 核算组
                  company 公司
                  customer 客商、供应商、客户
                  currency 货币
                  depart 部门
                  measurementunit 单位
                  staff 人员
                  creater 创建人
                  warehouse 仓库
                  portcity 港口
                  finance 财务组织 // 暂无
                  project 项目 // 暂无
              customerType 若dialogType类型为customer时需要传
                  null/undefined 返回所有
                  "10" 客商、客户、发票客户
                  "20" 供应商、开票单位、物流供应商
                  "30" 委托方
                  "40" 服务供应商
                  "50" 货主
                  "99" 其他
    @methods
        submit Function 点击查询并通过校验 才会有回调事件
        getSearchData Function 获取表单数据
          @return Object
    @demo
        /src/views/aggridDemo/masterDetailLazy.vue
    @author KYUUTA/chen
    @date 2020-12-17 14:30:42
    @updata 2020-12-30 15:44
-->
<template>
  <cnd-form-card-list
    ref="SearchForm"
    class="search-form"
    active-panel="1"
    :class-name="className_"
    :style="formCardStyle"
    :change="(v) => (activePanel = v)"
  >
    <!-- 查询条件 -->
    <cnd-form-card
      ref="cubeformCard"
      :title="$t('grid.others.queryConditions')"
      name="1"
      :hide-right="false"
      header-border-bottom
    >
      <!-- 查询结果 -->
      <template v-if="selectTag_.length > 0" slot="form-card-tag">
        <search-tag-group
          :list="selectTag_"
          :option="{ label: 'valueText' }"
          @onClose="handleCloseTag"
        />
      </template>
      <template v-if="type === 'top'" slot="form-card-btn">
        <!-- 查看更多按钮 -->
        <cube-button
          v-if="!!Object.keys(splitFormItems[1]).length"
          type="secondary"
          @click="collapseFilter"
        >
          {{ filterControlText }}
        </cube-button>
        <!-- 参数按钮 -->
        <slot name="others-button" />
        <slot name="parameter-button" />
        <!-- 查询重置按钮 -->
        <cube-button type="secondary" @click.native.stop="reset">{{
          $t('components.reset')
        }}</cube-button>
        <el-tooltip
          v-model="tips"
          effect="dark"
          content="Ctrl + Enter"
          placement="top-start"
        >
          <cube-button
            type="primary"
            @click.native.stop="submit(true, true, true)"
          >
            {{ $t('components.inquiry') }}
          </cube-button>
        </el-tooltip>
        <!-- <local-filter-btn
          ref="filterBtn"
          :type="type"
          :occultation-form="!!Object.keys(splitFormItems[1]).length"
          :show-button="true"
          :params-button="paramsButton"
          :read-only-filter="readOnlyFilter_"
          :model="searchInfo"
          @filterAction="filterAction"
          @reset="reset"
          @submit="submit(true, true, true)"
          @collapseFilter="collapseFilter"
        >
          <template slot="others-button">
            <slot name="others-button" />
          </template>
        </local-filter-btn> -->
      </template>
      <local-filter
        ref="cndFilter"
        v-resize="filterWidth"
        :type="type"
        ref-form="searchInfo"
        :model="searchInfo"
        :rules="searchRules"
        :no-more="!Object.keys(splitFormItems[1]).length"
        show-button
        :params-button="paramsButton"
        :label-width="labelWidth"
        @action="filterAction"
        @reset="reset"
        @submit="submit(true, true, true)"
        @callBack="filterCallBack"
      >
        <template
          v-for="(items, typeIndex) in splitFormItems"
          :slot="typeIndex ? 'occultationForm' : 'displayForm'"
        >
          <local-form-item
            v-for="(item, index) in items"
            :key="index"
            :label="item.label"
            :label-position="type === 'bottom' ? 'left' : 'top'"
            :outline="outlineType(item.type)"
            :custom-width="item.customWidth || undefined"
            :prop="
              item.type === 'elDatePicker' || item.type === 'doubleInput'
                ? item.value[0]
                : item.value
            "
            :error-msg="item.errorMessage || $t('components.pleaseEnter')"
          >
            <el-input
              v-if="item.type === 'elInput'"
              v-model="searchInfo[item.value]"
              :placeholder="$t('components.pleaseEnter')"
              clearable
              :disabled="item.disabled"
              @focus="item.focus && item.focus(item, $event)"
              @keyup.native.stop.enter="submit(true, true)"
              @clear="submit(false, isAutoQuery)"
            />

            <div v-else-if="item.type === 'doubleInput'" class="flexCC">
              <el-input
                v-model="searchInfo[item.value[0]]"
                :placeholder="$t('components.pleaseEnter')"
                clearable
                :disabled="item.disabled || false"
                @keyup.native.stop.enter="submit(true, true)"
                @clear="submit(false, isAutoQuery)"
              />
              <el-input
                v-model="searchInfo[item.value[1]]"
                :placeholder="$t('components.pleaseEnter')"
                clearable
                :disabled="item.disabled || false"
                @keyup.native.stop.enter="submit(true, true)"
                @clear="submit(false, isAutoQuery)"
              />
            </div>

            <!-- 复选框 -->
            <el-checkbox
              v-else-if="item.type === 'elCheckbox'"
              v-model="searchInfo[item.value]"
              :true-label="item.trueLabel"
              :false-label="item.falseLabel"
              :label="item.value"
              :disabled="item.disabled"
            >
              {{ item.placeholder }}
            </el-checkbox>

            <!-- 复选框组 -->
            <el-checkbox-group
              v-else-if="item.type === 'elCheckboxGroup'"
              v-model="searchInfo[item.value]"
              :min="item.min"
              :max="item.max"
            >
              <el-checkbox
                v-for="(v, i) in item.option"
                :key="i"
                :label="v.value"
                :disabled="v.disabled"
                >{{ v.label || v.value }}</el-checkbox
              >
            </el-checkbox-group>

            <!-- 开关 -->
            <el-switch
              v-else-if="item.type === 'elSwitch'"
              v-model="searchInfo[item.value]"
              :disabled="item.disabled"
              :active-text="item.activeText"
              :inactive-text="item.inactiveText"
              :active-value="item.activeValue"
              :inactive-value="item.inactiveValue"
            >
            </el-switch>

            <!-- 单选框组 -->
            <el-radio-group
              v-else-if="item.type === 'elRadioGroup'"
              v-model="searchInfo[item.value]"
            >
              <el-radio
                v-for="(v, i) in item.option"
                :key="i"
                :label="v.value"
                :disabled="v.disabled"
                >{{ v.label || v.value }}</el-radio
              >
            </el-radio-group>

            <!-- 下拉框 -->
            <cnd-select
              v-else-if="item.type === 'elSelect'"
              v-model="searchInfo[item.value]"
              filterable
              clearable
              :multiple="item.multiple"
              :placeholder="$t('components.pleaseEnter')"
              :disabled="item.disabled"
              @change="
                selectGet(
                  item,
                  searchInfo[item.value],
                  item.selectKey,
                  item.value,
                )
              "
            >
              <cnd-option
                v-if="!item.allHide"
                key="all"
                :label="$t('grid.others.all')"
                :value="undefined"
              />
              <cnd-option
                v-for="option in item.dict"
                :key="
                  option[
                    item.option && item.option.value
                      ? item.option.value
                      : 'value'
                  ]
                "
                v-bind="getSelectOptionProps(option, item)"
              />
            </cnd-select>
            <!-- 级联选择 -->
            <el-cascader
              v-else-if="item.type === 'elCascader'"
              :ref="`cascader${index}`"
              v-model="searchInfo[item.value]"
              size="mini"
              :clearable="item.clearable || false"
              :filterable="item.filterable || false"
              :collapse-tags="item.collapseTags !==undefined ? item.collapseTags:true"
              :options="item.dict"
              :placeholder="$t('components.pleaseEnter')"
              :disabled="item.disabled"
              :props="item.props || {}"
              @change="
              (res)=>cascaderGet(
                  res,
                  item.dict,
                  searchInfo[item.value],
                  item.selectKey,
                  item.value,
                  `cascader${index}`,
                )

              "
            />
            <!-- 日期选择 -->
            <el-date-picker
              v-else-if="
                item.type === 'elDatePicker' && item.value.length === 2
              "
              v-model="dateTimePick[`${item.value[0]}${item.value[1]}`]"
              :readonly="item.readonly || false"
              :disabled="item.disabled || false"
              :editable="item.editable || true"
              clearable
              :type="item.dateType ? item.dateType : 'daterange'"
              size="mini"
              :format="item.format"
              :unlink-panels="item.unlinkPanels"
              :start-placeholder="
                item.placeholder && item.placeholder.length
                  ? item.placeholder[0]
                  : $t('grid.others.startDate')
              "
              :end-placeholder="
                item.placeholder && item.placeholder.length > 1
                  ? item.placeholder[1]
                  : $t('grid.others.endDate')
              "
              :default-time="['00:00:00', '23:59:59']"
              :value-format="item.valueFormat"
              :picker-options="
                item.pickerOptions ? item.pickerOptions : pickerOptions
              "
              align="right"
              @blur="blurDatePicker"
              @change="handleChangeTime($event, item.value)"
            />

            <el-date-picker
              v-else-if="
                item.type === 'elDatePicker' && item.value.length !== 2
              "
              v-model="dateTimePick[`${item.value[0]}`][0]"
              :readonly="item.readonly"
              :disabled="item.disabled"
              :editable="item.editable"
              :unlink-panels="item.unlinkPanels"
              :format="item.format"
              clearable
              :type="item.dateType ? item.dateType : 'daterange'"
              size="mini"
              :placeholder="
                item.placeholder && item.placeholder.length
                  ? item.placeholder[0]
                  : $t('grid.others.startDate')
              "
              :picker-options="item.pickerOptions || pickerOptions"
              :value-format="item.valueFormat"
              align="right"
              @change="handleChangeTime($event, item.value)"
            />
            <slot
              v-else-if="
                item.type === 'cndInputDialog' ||
                item.type === 'cndInputDialogItem'
              "
              name="searchSelect"
              :item="item"
              :searchInfo="searchInfo"
              :change="handleChangeSelect"
            >
              <cnd-select
                v-model="searchInfo[`_preview${item.value}`]"
                :default-options="selectOptions_(item)"
                :remote="item.remote"
                :collapse-tags="item.collapseTags"
                :multiple="item.multiple"
                :multiple-limit="item.multipleLimit"
                :name="item.name"
                :value-key="valueKey_(item)"
                :disabled="item.disabled"
                :clearable="item.clearable"
                :size="item.size"
                :filterable="item.filterable"
                :filter-method="item.filterMethod"
                :loading="item.loading"
                :loading-text="item.loadingText"
                :no-match-text="item.noMatchText"
                :no-data-text="item.noDataText"
                :reserve-keyword="item.reserveKeyword"
                :default-first-option="item.defaultFirstOption"
                :popper-append-to-body="item.popperAppendToBody"
                :pagination="item.pagination"
                :allow-create="item.allowCreate"
                :autocomplete="item.autocomplete"
                :automatic-dropdown="item.automaticDropdown"
                :popper-class="item.popperClass"
                :popover-tags="item.popoverTags"
                :remote-method="item.getOptions"
                :get-select-option-props="item.getOptionProps"
                :is-bind-object="true"
                @pageChange="item.pageChange"
                @jumpPage="item.jumpPage"
                @focus="item.focus"
                @change="handleChangeSelect($event, item)"
                @visible-change="item.visibleChange"
                @inputAction="item.inputAction"
                @input="item.input"
              />
            </slot>
          </local-form-item>
        </template>
      </local-filter>
    </cnd-form-card>
  </cnd-form-card-list>
</template>

<script>
// 保存参数 选择参数
// 必填校验功能
import moment from 'moment'
import '../../../../lib/styles/components/SearchForm.scss'
import analytics from '../../../utils/analytics'
import { Validate } from '@cndinfo/cube-web-utils'
import localFormItem from '../../FormItem/index.js'
import localFilterBtn from '../../FilterBtn/index.js'
import localFilter from '../../Filter/index.js'
import SearchTagGroup from '../../SearchTagGroup/src/index.vue'
import { deepClone } from '../../AgGrid/src/utils'

export default {
  name: 'SearchForm',
  components: { localFormItem, localFilterBtn, localFilter, SearchTagGroup },
  props: {
    // 按钮组位置 top、bottom
    type: {
      type: String,
      default: 'top'
    },
    // 表单项配置列表
    formItems: {
      type: Array,
      required: true
    },
    // 表单label宽度
    labelWidth: {
      type: String,
      default: '85px'
    },
    // 是否显示选择参数、保存参数按钮
    paramsButton: {
      type: Boolean,
      default: true
    },
    // 是否自动查询
    autoQuery: {
      type: String,
      default: ''
    },
    // 隐藏多余一行的内容
    lineLimit: {
      type: Boolean,
      default: true
    },
    // 是否默认展开
    isCollapse: {
      type: [String, Boolean],
      default: ''
    }
    // 默认展示行数
    // rows: {
    //   type: Number,
    //   default: ''
    // }
    // 面板激活状态
    // activePanel: {
    //   type: String,
    //   default: "1"
    // }
  },
  data() {
    return {
      filterControlText: this.$t('components.viewMore'),
      searchFormValues: {},
      occultationShow: false,
      SearchFormHeight: '',
      formItemsReset: this.deepClone(this.formItems),
      // formItemsReset: JSON.parse(JSON.stringify(this.formItems)),
      tips: false,
      // isAutoQuery: false,
      isAutoQuery:
        this.autoQuery !== ''
          ? this.autoQuery
          : this.getAutoQuery('VUE_APP_AUTO_QUERY')
            ? this.getAutoQuery('VUE_APP_AUTO_QUERY')
            : false,
      width: document.body.clientWidth,
      num: 0,
      searchInfo: this.initForm(),
      searchRules: this.initFormRules(),
      dateTimePick: this.initDateTimePick(),
      splitFormItems: [],
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t('grid.others.lastWeek'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('grid.others.mostRecentMonth'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('grid.others.lastThreeMonths'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      isClickReset: false,
      searchDataObject: {},
      searchOtherObject: {},
      searchCndInputDialogObject: {},
      doubleInputObject: {},
      activePanel: '1' // 面板激活状态
    }
  },
  computed: {
    className_() {
      const className = ['search-form-collapse']
      className.push({ 'search-form-occultation': this.occultationShow })
      className.push({
        shadow: this.occultationShow && this.activePanel.length
      })
      return className
    },
    formCardStyle() {
      if (this.occultationShow && this.activePanel.length) {
        return {
          'min-height': this.SearchFormHeight
            ? this.SearchFormHeight + 'px'
            : 'auto',
          transition: '0.3s'
        }
      } else if (this.occultationShow && !this.activePanel.length) {
        return { 'min-height': '55px', transition: '0.3s' }
      } else if (!this.occultationShow) {
        return { 'min-height': 'auto', transition: '0.3s' }
      }
      return ''
    },
    formItemObj() {
      const result = {}
      this.formItems.forEach((v) => {
        // 数组类型的保存第一个字符串
        if (v.type === 'elDatePicker' && Array.isArray(v.value)) {
          result[v.value[0]] = v
        } else {
          result[v.value] = v
        }
      })
      return result
    },
    selectTag_() {
      const result = []
      const keys = Object.entries(this.searchDataObject)
      keys.forEach(([k, v]) => {
        const item =
          this.formItemObj[k] || this.doubleInputObject[`_doubleInput${k}`]
        // doubleInput 类型的 判断一波是否有值 -- 因为值是附在其他参数内的所以无法正常判断
        if (item && item.type === 'doubleInput' && Array.isArray(item.value)) {
          v = item.value
            .map((field) => {
              return this.searchDataObject[field]
            })
            .filter((val) => val)
        }
        // 去除空数组
        if (Array.isArray(v)) {
          v = v.length > 0
        }

        // v 值内容已被改变，后期取值不要使用这边的v
        // 有值、可以为0 、item不能为空、v的值不能为false对应的值（checkbox中true 和 false）
        if ((v || v === 0) && item && v !== item.falseLabel) {
          let value = ''
          // 选择框
          if (item.type === 'elSelect') {
            // 字符串的话就是还没取到值
            const list = Array.isArray(item.dict) ? item.dict : []
            const searchItem = this.searchDataObject[k]
            const option = item.option || {}
            const optionValue = option.value || 'value'
            const optionLabel = option.label || 'label'

            const searchItemArray = Array.isArray(searchItem)
              ? searchItem
              : [searchItem]

            const labelList = searchItemArray.map((val) => {
              const record =
                list.find((item) => item[optionValue] === val) || {}
              return record[optionLabel] || record[optionValue] || val
            })

            value = labelList.join('; ')
          } else if (
            ['cndInputDialog', 'cndInputDialogItem'].indexOf(item.type) !== -1
          ) {
            // 搜索选择框
            const otterItem = this.searchCndInputDialogObject[k] || {}
            value = otterItem.valueText || ''
            if (!value) {
              const searchItem = this.searchInfo[`_preview${k}`] || ''
              if (Array.isArray(searchItem)) {
                value = searchItem.join('; ')
              } else {
                value = searchItem
              }
            }
          } else if (item.type === 'elCheckbox') {
            value = item.placeholder
          } else if (item.type === 'elDatePicker') {
            value = item.value
              .map((o) => moment(this.searchDataObject[o]).format('YYYY-MM-DD'))
              .join(' 到 ')
          } else if (item.type === 'elCascader') {
            // 联级选择
            const list = Array.isArray(item.dict) ? deepClone(item.dict) : []

            const flatList = []

            while (list.length) {
              const record = list.pop()
              const { children, ...restItem } = record

              flatList.push(restItem)

              if (Array.isArray(children) && children.length) {
                list.push(...children)
              }
            }

            const searchItem = this.searchDataObject[k]
            const option = item.props || {}
            const optionValue = option.value || 'value'
            const optionLabel = option.label || 'label'

            const searchItemArray = Array.isArray(searchItem)
              ? searchItem
              : [searchItem]

            const labelList = searchItemArray.map((val) => {
              if (Array.isArray(val)) {
                return val.map((childVal) => {
                  const record =
                    flatList.find((item) => item[optionValue] === childVal) || {}
                  return record[optionLabel] || record[optionValue] || val
                }).join('/')
              }

              const record =
                flatList.find((item) => item[optionValue] === val) || {}
              return record[optionLabel] || record[optionValue] || val
            })

            value = labelList.join('; ')
          } else if (item.type === 'doubleInput') {
            // 两个input
            value = item.value
              .map((o) => this.searchDataObject[o])
              .filter((o) => o)
              .join('; ')
          } else {
            value = v
          }

          // 对于搜索select来说 无值的话就不显示了
          // elCheckboxvalue无值
          if (
            value ||
            ['cndInputDialog', 'cndInputDialogItem'].indexOf(item.type) === -1
          ) {
            result.push({
              ...item,
              valueText: [item.label, value].filter((o) => o).join(': ')
            })
          }
        }
      })
      return result
    },
    labelPosition_() {
      return (item) => {
        if (this.type === 'bottom') {
          return 'left'
        } else {
          return 'top'
        }
      }
    },
    readOnlyFilter_() {
      return this.activePanel.length === 0
    },
    valueKey_() {
      return (item) => {
        if (item.option) {
          return item.option.valueKey || item.option.value || 'value'
        }
        return 'value'
      }
    },
    selectOptions_() {
      return (item, key = 'options') => {
        const config = Object.assign(
          { label: 'label', value: 'value' },
          item.option
        )
        const options = Array.isArray(item[key]) ? item[key] : []
        return options.map((v) => {
          return {
            ...v,
            _label: v[config.label],
            _value: v[config.value]
          }
        })
      }
    }
  },
  watch: {
    activePanel(value) {
      try {
        console.log(value)
        if (Array.isArray(value)) {
          // 收起卡片时候，关闭全部打开
          if (this.occultationShow && !value.length) {
            // 等待收起动画结束
            setTimeout(() => {
              this.collapseFilter(false)
              // this.$refs.filterBtn.collapseFilter(false)
            }, 500)
          }
          try {
            const analyticsInstance = analytics.getAnalyticsInstance(this)
            analyticsInstance.reportEvent('advanced_search_toggle', {
              toggle_type: value.length === 2 ? 'unfold' : 'fold'
            })
          } catch (e) {
            console.log()
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    formItems() {
      this.filterWidth()
    }
  },
  beforeMount() {
    this.filterWidth()
  },
  created() {
    window.addEventListener('keydown', this.handkeyCode, true) // 开启监听键盘按下事件
  },
  mounted() {
    this.$nextTick(() => {
      this.type === 'top' &&
        (this.SearchFormHeight = this.$refs.SearchForm.$el.offsetHeight)
    })
    this.searchDataObject = this.getFormValues()
    this.searchFormValues = this.getFormValues()
    this.setSearchCndInputDialogObject()
  },
  methods: {
    setSearchCndInputDialogObject() {
      const record = {}
      Object.keys(this.searchOtherObject).forEach((key) => {
        record[key] = this.searchOtherObject[key]
      })
      this.searchCndInputDialogObject = record
    },

    getSelectOptionProps(record, item) {
      const { option, getOptionProps } = item || {}
      const { label, value } = option || {}

      return {
        label: record[label || 'label'],
        value: record[value || 'value'],
        ...getOptionProps?.(record)
      }
    },
    // formItem 是否显示 outline
    outlineType(type) {
      const reg = new RegExp(
        'elCheckbox|elCheckboxGroup|elSwitch|elRadioGroup',
        'g'
      )
      return reg.test(type)
    },
    filterCallBack(val) {
      this.isCollapse_ = val
    },
    forEach(array, iteratee) {
      let index = -1
      const length = array.length
      while (++index < length) {
        iteratee(array[index], index)
      }
      return array
    },
    // 深拷贝
    deepClone(target, map = new WeakMap()) {
      if (typeof target === 'object') {
        const isArray = Array.isArray(target)
        const cloneTarget = isArray ? [] : {}

        if (map.get(target) || !target) {
          return target
        }
        map.set(target, cloneTarget)

        const keys = isArray ? undefined : Object.keys(target)
        this.forEach(keys || target, (value, key) => {
          if (keys) {
            key = value
          }
          cloneTarget[key] = this.deepClone(target[key], map)
        })

        return cloneTarget
      } else {
        return target
      }
    },
    collapseFilter(state = true) {
      if (this.readOnlyFilter_ && state) return
      this.filterControlText =
        this.filterControlText === this.$t('components.collapse')
          ? this.$t('components.viewMore')
          : this.$t('components.collapse')
      // this.rotate =
      //   this.rotate === 'rotate(0deg)' ? 'rotate(180deg)' : 'rotate(0deg)'
      this.occultationShow = !this.occultationShow
      this.$refs.cndFilter.collapseFilter()
      // this.$emit('collapseFilter')
    },
    handkeyCode(event) {
      if (event.ctrlKey && event.keyCode === 13) {
        this.submit(true, true)
      }
    },
    getAutoQuery(name) {
      return window.configs &&
        window.configs[name] &&
        process.env.NODE_ENV !== 'development'
        ? window.configs[name]
        : process.env[name]
    },
    filterWidth() {
      const width = document.body.clientWidth
      let num = 24
      width >= 1200 ? (num = 24) : width <= 767 ? (num = 12) : (num = 16)
      this.splitFormItem(num)
    },
    // 分组隐藏和显示
    splitFormItem(num) {
      let length = 0
      const splitFormItems = [[], []]
      this.formItems.forEach((item, index) => {
        if (!item.hidden) {
          if (length < num) {
            splitFormItems[0].push(item)
            length += item.customWidth || 4
          } else {
            splitFormItems[1].push(item)
          }
        }
      })
      this.splitFormItems = splitFormItems
    },
    // filterWidth() {
    //   const width = document.body.clientWidth
    //   if (this.type === 'bottom') {
    //     width > 1200
    //       ? (this.num = 6)
    //       : width < 1200 && width > 767
    //         ? (this.num = 4)
    //         : (this.num = 3)
    //   } else {
    //     width > 1200
    //       ? (this.num = 6)
    //       : width < 1200 && width > 767
    //         ? (this.num = 4)
    //         : (this.num = 3)
    //   }
    //   this.splitFormItem(this.num)
    // },
    // splitFormItem(num) {
    //   const splitFormItems = [[], []]
    //   this.formItems.forEach((item, index) => {
    //     if (!item.hidden) {
    //       this.lineLimit
    //         ? index < num
    //           ? splitFormItems[0].push(item)
    //           : splitFormItems[1].push(item)
    //         : splitFormItems[0].push(item)
    //     }
    //   })
    //   this.splitFormItems = splitFormItems
    //   console.log('splitFormItems', this.splitFormItems)
    //   // const splitFormItems = [[], []]
    //   // let occultationNum = 0
    //   // let displayFormNum = 0
    //   // this.formItems.forEach((item, index) => {
    //   //   if (!item.hidden) {
    //   //     if (item.itemType && item.itemType === 'occultation') {
    //   //       if (splitFormItems[1][tempIndex]) {
    //   //         splitFormItems[1][tempIndex].push(item)
    //   //       } else {
    //   //         splitFormItems[1][tempIndex] = [item]
    //   //       }
    //   //       occultationNum++
    //   //     } else {
    //   //       const tempIndex = Math.floor(displayFormNum / 4)
    //   //       if (splitFormItems[0][tempIndex]) {
    //   //         splitFormItems[0][tempIndex].push(item)
    //   //       } else {
    //   //         splitFormItems[0][tempIndex] = [item]
    //   //       }
    //   //       displayFormNum++
    //   //     }
    //   //   }
    //   // })
    //   // this.splitFormItems = splitFormItems
    // },
    initDateTimePick(formItems = this.formItems) {
      const result = {}
      formItems.forEach((item) => {
        if (item.type === 'elDatePicker') {
          const dateValue =
            item.default && item.default.length
              ? item.default
              : [
                moment()
                  .subtract(3, 'months')
                  .startOf('day')
                  .format('YYYY-MM-DDTHH:mm:ss'),
                moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss')
              ]
          if (item.value[1]) {
            result[`${item.value[0]}${item.value[1]}`] = dateValue
          } else {
            result[`${item.value[0]}`] = dateValue
          }
        }
      })
      return result
    },
    // 初始化表单值
    initForm(formItems = this.formItems, reset = false) {
      return formItems.reduce((prev, next) => {
        if (next.type === 'elDatePicker') {
          const dateValue =
            next.default && next.default.length
              ? next.default
              : [
                moment()
                  .subtract(3, 'months')
                  .startOf('day')
                  .format('YYYY-MM-DDTHH:mm:ss'),
                moment().endOf('day').format('YYYY-MM-DDTHH:mm:ss')
              ]
          dateValue[1] &&
            (dateValue[1] =
              moment(dateValue[1]).format('LTS') === '00:00:00'
                ? moment(dateValue[1]).endOf('day')._d
                : moment(dateValue[1]).format('YYYY-MM-DD HH:mm:ss'))
          prev[next.value[0]] = dateValue[0]
          prev[next.value[1]] = dateValue[1]

          if (reset) {
            this.dateTimePick[`${next.value[0]}${next.value[1] || ''}`] = [
              dateValue[0],
              dateValue[1]
            ]
          }

          return prev
        }

        // 若为弹窗选择储存name以用于保存参数
        if (
          next.type === 'cndInputDialog' ||
          next.type === 'cndInputDialogItem'
        ) {
          if (next.default === 0 || next.default) {
            if (Array.isArray(next.default)) {
              prev[`_preview${next.value}`] = next.default.map((val, index) => {
                const labelData = Array.isArray(next.labelDefault)
                  ? next.labelDefault
                  : [next.labelDefault]
                return {
                  label: labelData[index],
                  _label: labelData[index],
                  value: val,
                  _value: val
                }
              })
            } else {
              prev[`_preview${next.value}`] = {
                label: next.labelDefault,
                _label: next.labelDefault,
                value: next.default,
                _value: next.default
              }
            }
          }
          if (reset) {
            if (
              next.type === 'cndInputDialog' ||
              next.type === 'cndInputDialogItem'
            ) {
              this.$set(this.searchOtherObject, next.value, {
                valueText: Array.isArray(next.labelDefault)
                  ? next.labelDefault.join(',')
                  : next.labelDefault
              })
            }
          }
        }
        if (next.type === 'elCheckbox') {
          prev[next.value] = next.checked || !!next.default
        } else if (next.type === 'elCheckboxGroup') {
          prev[next.value] = next.default || []
        } else if (next.type === 'doubleInput') {
          next.value?.forEach((key, index) => {
            prev[key] = next.default?.[index]
          })
        } else {
          prev[next.value] = next.default
        }
        return prev
      }, {})
    },
    initFormRules() {
      const result = {}
      this.formItems.forEach((item) => {
        if (item.required) {
          if (item.type === 'elDatePicker') {
            result[item.value[0]] = [
              {
                validator: (rule, value, cb) => {
                  if (
                    this.searchInfo[item.value[0]] ||
                    this.searchInfo[item.value[1]]
                  ) {
                    cb()
                  } else {
                    cb(new Error('no'))
                  }
                },
                trigger: ['blur', 'change'],
                required: true
              }
            ]
          } else {
            result[item.value] = [
              {
                required: true,
                trigger: ['blur', 'change']
              }
            ]
          }
        }
      })

      return result
    },
    // 选择参数回填
    filterAction(params) {
      this.searchInfo = params
      // this.searchInfo = Object.assign(this.searchInfo, params)
      const datePcikerItem = this.formItems.filter(
        (item) => item.type === 'elDatePicker'
      )
      datePcikerItem.forEach((item) => {
        this.dateTimePick[`${item.value[0]}${item.value[1] || ''}`] =
          [params[item.value[0]], params[item.value[1]]] ||
          this.dateTimePick[`${item.value[0]}${item.value[1]}`]
      })
      // this.submit()
      this.submit(true, true)
    },
    blurDatePicker() {
      this.$emit('blur-date-picker')
    },
    // 选择日期
    handleChangeTime(dateArray, valueArray) {
      if (valueArray[1]) {
        this.searchInfo[valueArray[0]] = dateArray
          ? moment(dateArray[0]).format('YYYY-MM-DD HH:mm:ss')
          : undefined
        // this.searchInfo[valueArray[0]] = dateArray
        //   ? dateArray[0]
        //   : undefined
        // this.searchInfo[valueArray[1]] = dateArray
        //   ? dateArray[1]
        //   : undefined
        this.searchInfo[valueArray[1]] = dateArray
          ? moment(dateArray[1]).format('LTS') === '00:00:00'
            ? moment(dateArray[1]).endOf('day')._d
            : moment(dateArray[1]).format('YYYY-MM-DD HH:mm:ss')
          : undefined
        // this.searchInfo[valueArray[1]] = dateArray
        //   ? new Date(new Date(new Date((dateArray[1].getFullYear() + '-' + (dateArray[1].getMonth() + 1) + '-' + dateArray[1].getDate()).replace(/-/g, '/')).getTime()).getTime() + 24 * 60 * 60 * 1000 - 1)
        //   : undefined
      } else {
        this.searchInfo[valueArray[0]] = dateArray
          ? moment(dateArray).format('YYYY-MM-DD HH:mm:ss')
          : undefined
        // this.searchInfo[valueArray[0]] = dateArray
        //   ? new Date(new Date(new Date((dateArray.getFullYear() + '-' + (dateArray.getMonth() + 1) + '-' + dateArray.getDate()).replace(/-/g, '/')).getTime()).getTime() + 24 * 60 * 60 * 1000 - 1)
        //   : undefined
      }
      this.submit(false, this.isAutoQuery)
    },
    handleChangeSelect(val, item, inside = true, needSubmit = true) {
      // inside 判断是否为内部触发, 外部给值统一走单选(外部值处理完)
      // needSubmit 有些select初始化设置了默认值会触发change
      if (item.multiple && inside) {
        this.searchInfo[item.value] = val.map((v) => v._value)
        const valueText = val.map((v) => v._label).join(',')
        // 用于在tags显示
        this.searchOtherObject[item.value] = { ...val, valueText }
      } else {
        this.searchInfo[item.value] = val._value
        // 用于在tags显示
        this.searchOtherObject[item.value] = { ...val, valueText: val._label }
      }
      // 执行 change 事件
      item.change && item.change(val, item)
      // 由于某些select设置了默认值但是默认值是由于接口获取的，获取完后会触发change
      // 接口初始化后触发的change为了显示tags，而不触发搜索，所以做了此判断
      if (needSubmit) {
        this.submit(false, this.isAutoQuery)
      } else {
        this.searchDataObject = this.getFormValues()
      }
    },
    submit(flagFold = true, search = false, isClick = false) {
      this.validate().then((valid) => {
        if (valid) {
          this.tips = false
          // 点击查询触发的查询 并 处于展开的状态
          if (isClick && this.occultationShow) {
            // this.$refs.filterBtn.collapseFilter()
            this.collapseFilter()
          }
          this.$emit('searchValue', this.searchInfo)
          if (search) {
            this.searchFormValues = this.getFormValues()
            this.$emit('search', this.searchFormValues)
            this.setSearchCndInputDialogObject()
          }

          flagFold && (this.activePanel = '1')
          try {
            const searchDataObject = this.getFormValues()
            if (search) {
              this.searchDataObject = searchDataObject
            }
            const allSearchConditionArr = Object.keys(searchDataObject)
            const nullSearchParams = []
            const searchConditionArr = []
            for (let i = 0; i < allSearchConditionArr.length; i++) {
              const item = allSearchConditionArr[i]
              if (searchDataObject[item]) {
                searchConditionArr.push(item)
              } else {
                nullSearchParams.push(item)
              }
            }
            if (this.isClickReset) {
              this.isClickReset = false
              return
            }
            const analyticsInstance = analytics.getAnalyticsInstance(this)
            analyticsInstance.reportEvent('advanced_search_trigger', {
              valid_search_params: searchConditionArr,
              null_search_params: nullSearchParams,
              trigger_type: flagFold ? '点击查询按钮' : '选择下拉框 '
            })
          } catch (e) {
            console.log(e)
          }
        }
      })
    },
    selectGet(data, oldValue, selectKey, FormKey) {
      let obj = {}
      const list = data.dict
      const option = data.option || {}
      obj = list.find((item) => {
        return item[option.value || 'value'] === oldValue
      })
      if (selectKey) {
        this.searchInfo[FormKey] = obj[selectKey]
      }
      this.submit(false, this.isAutoQuery)
    },
    cascaderGet(res, list, oldValue, selectKey, FormKey, refKey) {
      const checkedNodes = this.$refs[refKey][0].getCheckedNodes() || []
      const valueText = checkedNodes.map((v) => v.label).join(',')
      this.searchOtherObject[FormKey] = { valueText: valueText } // 记录选中的文本信息
      let obj = {}
      obj = list.find((item) => {
        return item.sCodeValue === oldValue
      })
      if (selectKey) {
        this.searchInfo[FormKey] = obj[selectKey]
      } else {
        this.searchInfo[FormKey] = res
      }
      const el = this.$refs[refKey][0].$el
      el.style.height = res.length ? 'auto' : ''
      this.submit(false, this.isAutoQuery)
    },
    getFormValues() {
      // const reg = new RegExp(/\s/)
      const result = {}
      const datePickerItem = this.formItems.filter(
        (item) => item.type === 'elDatePicker'
      )

      this.formItems.forEach((item) => {
        if (item.type === 'doubleInput') {
          this.doubleInputObject[`_doubleInput${item.value[0]}`] = item
        }
        if (
          item.type === 'cndInputDialog' ||
          item.type === 'cndInputDialogItem'
        ) {
          if (!this.searchOtherObject?.[item.value]) {
            this.$set(this.searchOtherObject, item.value, {
              valueText: Array.isArray(item.labelDefault)
                ? item.labelDefault.join(',')
                : item.labelDefault
            })
          }
        }
      })

      Object.keys(this.searchInfo)
        .filter((key) => !key.includes('_preview'))
        .forEach((key) => {
          result[key] =
            typeof this.searchInfo[key] === 'string'
              ? this.searchInfo[key].replace(/^\s+|\s+$/g, '')
              : !Validate.isUndeFinedOrNullOrBlank(this.searchInfo[key])
                ? this.searchInfo[key]
                : undefined
        })
      if (datePickerItem.length) {
        datePickerItem.forEach((item) => {
          item.value.forEach((date) => {
            result[date] = result[date]
              ? moment(result[date]).format('YYYY-MM-DDTHH:mm:ss')
              : undefined
          })
        })
      }
      console.log('result', result)
      return result
    },
    getSearchData() {
      return this.searchFormValues
    },
    validate() {
      return new Promise((resolve, reject) => {
        const validate = this.$refs.cndFilter.validate()
        resolve(validate)
      })
    },
    reset() {
      this.searchInfo = this.initForm(this.formItemsReset, true)
      this.isClickReset = true
      this.searchFormValues = this.getFormValues()
      this.setSearchCndInputDialogObject()
      // this.dateTimePick = this.initDateTimePick(this.formItemsReset)
      this.submit(false, true)
      try {
        const analyticsInstance = analytics.getAnalyticsInstance(this)
        analyticsInstance.reportEvent('advanced_search_reset_click')
      } catch (e) {
        console.log(e)
      }
    },
    handleCloseTag({ value: tag }) {
      if (tag.disabled || tag.required) return
      delete this.searchDataObject[tag.value]
      this.searchDataObject = { ...this.searchDataObject }
      if (tag.type === 'elInput') {
        // 普通输入框
        this.searchInfo[tag.value] = ''
      } else if (tag.type === 'elCheckbox') {
        // 多选框
        this.searchInfo[tag.value] = tag.falseLabel
      } else if (tag.type === 'elDatePicker') {
        // 日期选择框
        const key = tag.value.join('')
        this.dateTimePick[key] = []
        tag.value.forEach((v) => {
          this.searchInfo[v] = ''
        })
      } else if (
        ['cndInputDialog', 'cndInputDialogItem'].indexOf(tag.type) !== -1
      ) {
        // 选择框-搜索框
        this.searchInfo[tag.value] = undefined
        this.searchInfo[`_preview${tag.value}`] = ''
      } else if (tag.type === 'doubleInput') {
        tag.value.forEach((v) => {
          this.searchInfo[v] = undefined
        })
      } else {
        this.searchInfo[tag.value] = undefined
      }
      this.submit(true, true)
    },
    // 提供给外部调用，修改 searchInfo 的值，目前仅支持修改elInput类型的值
    setSearchInfo(key, value) {
      const item = this.formItems.find((v) => v.value === key)
      if (item && item.type === 'elInput') {
        this.searchInfo[key] = value
      } else {
        console.error('仅支持修改elInput类型的值')
      }
    }
  }
}
</script>
